import React from 'react';
// logic
import { Formik, Form } from 'formik';
import useTicketForm from './use-ticket-form';
// components
import TicketFormContainer from '../../ui/containers/ticketFormContainer';
import TicketFormBody from './ticket-form-body';
import { TicketFormFooter } from './ticket-form-footer';

const TicketForm = ({ ticketFormData, className }) => {
  const {
    // ticketFormSettings,
    onSubmit,
    onCancel,
    onCancelTicket,
    onMarkTicketAsDone,
    isQuoteAccepted,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    isDraft,
    draftErrors,
  } = ticketFormData;

  const {
    showErrors,
    setShowErrors,
    isWaitingForResponse,
    backendErrors,
    beforeOnSubmit,
  } = useTicketForm({ onSubmit });

  return (
    <TicketFormContainer className={className}>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={beforeOnSubmit()}
      >
        {({ errors, dirty, values, submitForm: submitFormikForm }) => {
          const ticketFormBodyData = {
            showErrors,
            backendErrors,
            values,
            initialValues,
            isReadOnly,
            isEdit,
            isDraft,
            draftErrors,
          };
          console.error(errors);
          const ticketFormFooterData = {
            backendErrors,
            setShowErrors,
            isWaitingForResponse,
            submitFormikForm,
            onCancel,
            onCancelTicket,
            onMarkTicketAsDone,
            isQuoteAccepted,
            isEdit,
            isReadOnly,
            dirty,
          };
          return (
            <Form>
              <TicketFormBody ticketFormBodyData={ticketFormBodyData} />
              <TicketFormFooter ticketFormFooterData={ticketFormFooterData} />
            </Form>
          );
        }}
      </Formik>
    </TicketFormContainer>
  );
};

export default TicketForm;
